module.exports = __webpack_public_path__ + "static/media/jamiedomingo_resume.fd917072.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/jamiedomingo_resume.pdf
// module id = 29
// module chunks = 0